import { fetcher } from '@commenda/utils';
import { BASE_URL } from './helpers';

export const deleteWorkflowTemplateLink = async (
  workflowLinkId: string
): Promise<Response> => {
  const res = await fetcher(`${BASE_URL}/links/${workflowLinkId}`, {
    method: 'DELETE',
  });
  return res;
};
